import z from 'zod';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const DbtAction = z.enum([
  '',
  'dbt_export_data_to_s3',
  'dbt_export_panel_data',
  'export_tinuiti_reviews_to_csv',
  'export_workday_candidates',
  'export_workday_employees',
  'export_workday_candidates_needing_resumes_to_csv',
  'export_workday_employees_needing_resumes_to_csv',
  'export_workday_resumes_needing_parsing_export',
  'workday_resume_data_export',
  's3_to_raw_resume_data',
  'export_peregrine_outputs',
  'export_sweetgreen_legion_data',
  'export_nopd_data',
  'export_quality_of_hire',
]);
export type DbtAction = z.infer<typeof DbtAction>;

export const SnowflakeIntegration = BaseIntegration.extend({
  integrationType: z.literal('Snowflake'),
  organizationId: z.string(),
  dbtAction: DbtAction,
  dataSetId: z.string(),
  databaseId: z.string(),
  versionId: z.string(),
});

export type SnowflakeIntegration = z.infer<typeof SnowflakeIntegration>;
